// announcementServices.js

import apiClient from './apiClient';

export const markAnnouncementAsRead = async (announcementId, userId) => {
    const data = {
        announcement_id: announcementId,
        user_id: userId,
    };

    const response = await apiClient.post(
        '/announcements.php?action=markAsRead',
        data,
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return response.data;
};

export const fetchAnnouncements = async (userId, isDirector, hideRead, page = 1, pageSize = 10) => {
    if (!userId) {
        console.error('Errore: userId non definito');
        return { status: 'error', data: [], total: 0, page, pageSize };
    }

    try {
        const response = await apiClient.get(
            `/announcements.php?action=fetch&user_id=${userId}&is_director=${isDirector}&hide_read=${hideRead}&page=${page}&pageSize=${pageSize}`
        );

        const data = response.data;

        if (!data || data.status !== 'success' || !Array.isArray(data.data)) {
            console.error('Errore: risposta non valida o vuota:', data);
            return { status: 'error', data: [], total: 0, page, pageSize };
        }

        return {
            status: 'success',
            data: data.data,
            total: hasTotal(data) ? data.total : data.data.length,
            page: data.page ?? page,
            pageSize: data.pageSize ?? pageSize
        };
    } catch (error) {
        console.error('Errore nel recupero degli annunci:', error);
        return { status: 'error', data: [], total: 0, page, pageSize };
    }
};

const hasTotal = (obj) => {
    return obj && Object.prototype.hasOwnProperty.call(obj, 'total');
};

export const getAnnouncementViews = async (announcementIds) => {
    if (!Array.isArray(announcementIds) || announcementIds.length === 0) {
        console.error('Nessun ID annuncio fornito per recuperare le visualizzazioni.');
        return [];
    }

    try {
        const views = await Promise.all(
            announcementIds.map(async (id) => {
                const response = await apiClient.get(`/views.php?action=getAnnouncementViews&announcement_id=${id}`);
                return { announcementId: id, views: response.data };
            })
        );
        return views;
    } catch (error) {
        console.error('Errore nel recupero delle visualizzazioni degli annunci:', error);
        throw error;
    }
};

export const addAnnouncement = async (formData) => {
    try {
        const response = await apiClient.post('/announcements.php?action=create', formData);
        return response.data;
    } catch (error) {
        console.error('Errore in addAnnouncement:', error.response?.data ?? error.message);
        throw error;
    }
};

export const removeAnnouncement = async (announcementId) => {
    const response = await apiClient.delete(`/announcements.php?action=delete&announcement_id=${announcementId}`);
    return response.data;
};

export const updateAnnouncement = async (formData) => {
    try {
        const response = await apiClient.post('/announcements.php?action=update', formData);
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'aggiornamento dell\'annuncio:', error);
        throw error;
    }
};
